// Любой код ISO 4217: счета студента приходят из HubSpot и не ограничены EUR/USD/GBP.
type Currency = string;

export const formatPrice = (price: number, currency: Currency, locale?: string): string =>
  new Intl.NumberFormat(locale || 'en-IE', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
